import "./Header.css";
import logo from "./lgo.png";
export default function Header() {
  return (
    <div className="Header">
      <img
        className="main-logo"
        src={logo}
        alt="Logo"
        height={150}
        width={150}
      />
    </div>
  );
}
